import React, { useEffect } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import { theme } from "./styles"
import "./styles.css";

const Selector = ({
   search,
   options,
   placeholder,
   selected,
   onChange,
   disabled,
   value,
   isClearable,
   onKeyDown,
   onInput,
   onInputCapture,
   onInputChange,
   getOptionLabel = () => {},
   noOptionsMessage = null,
}) => {
   let selectRef = null;

   useEffect(() => {
      if (!selected) {
         selectRef.select.clearValue();
      }
   }, [selected, selectRef]);

   return (
      <Select
         ref={(ref) => {
            selectRef = ref;
         }}
         isClearable={isClearable}
         isSearchable={search ?? false}
         options={options}
         placeholder={placeholder ?? "Selecione..."}
         noOptionsMessage={() => noOptionsMessage ?? "Não encontrado"}
         defaultValue={
            !!options && options.find((option) => option.value === selected)
         }
         onChange={onChange}
         theme={theme}
         value={!!options && options.find((option) => option.value === value?.value)}
         className="logar-select"
         isDisabled={disabled || false}
         menuPortalTarget={document.body}
         styles={{ menuPortal: base => ({ ...base, zIndex: 9999}) }}
         onKeyDown={onKeyDown ?? null}
         onInput={onInput ?? null}
         onInputCapture={onInputCapture ?? null}
         onInputChange={onInputChange ?? null}
         getOptionLabel={(option) => getOptionLabel(option) ?? option.label}
      ></Select>
   );
};

Selector.propTypes = {
   search: PropTypes.bool,
   options: PropTypes.array.isRequired,
   placeholder: PropTypes.string,
   selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChange: PropTypes.func,
   disabled: PropTypes.bool,
};

export default Selector;
